import "./Transactions.css";
import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import FormModal from "../../../Components/Molecules/FormModal/FormModal";
import { BarLoader } from "react-spinners";
import { BaseURL } from "../../../Hooks/URL";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import TextFieldInput from "../../../Components/Atoms/Inputs/TextField/TextFieldInput";
import { styled } from "@mui/material/styles";
import { images } from "../../../Assets/assetsHelper";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import Filter from "../../../Components/Molecules/Filter/Filter";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import FilterListIcon from "@mui/icons-material/FilterList";
import IconButton from "@mui/material/IconButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import { Pagination } from "@mui/material";
import Typography from "@mui/material/Typography";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&:first-child": {
    borderRadius: "5px 0 0 0",
  },
  "&:last-child": {
    borderRadius: "0 5px 0 0",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--primary)",
    color: theme.palette.common.white,
    fontSize: "15px",
  },
}));

const columns = [
  {
    id: "code",
    label: "Transaction ID",
    minWidth: 50,
  },
  // {
  //   id: "paymobTransactionId",
  //   label: "Paymob Transaction ID",
  //   minWidth: 50,
  // },
  {
    id: "account",
    label: "Account Code",
    minWidth: 100,
  },
  {
    id: "netAmountCents",
    label: "Net Amount",
    minWidth: 100,
  },
  {
    id: "totalAmountCents",
    label: "Total Amount",
    minWidth: 100,
  },
  {
    id: "manualTransaction",
    label: "Manual Payment Method",
    minWidth: 100,
  },
  { id: "createdAt", label: "Paid At", minWidth: 100 },
];

function Transactions({
  page,
  rowsPerPage,
  handleChangeRowsPerPage,
  searchData,
  search,
  setSearchData,
  setSearch,
  transactions,
  navigate,
  handleChangePage,
  loading,
  pageCount,
  transactionsNumber,
  sortBy,
  sortOrder,
  filters,
  handleSortChange,
  handleSortOrderChange,
  handleFilterChange,
  setPage,
  transactionsSummary,
  getFilterQueryString,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [showFilters, setShowFilters] = useState(!isMobile);

  return (
    <div className="mainContainer">
      {/* Summary Section */}
      {transactions && transactions.length > 0 && (
        <>
          {transactionsSummary?.map((transaction) => {
            return (
              <Box className="cont" sx={{ mb: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Box
                      sx={{ p: 2, backgroundColor: "white", borderRadius: 1 }}
                    >
                      <Typography variant="subtitle2" color="text.secondary">
                        Net Amount
                      </Typography>
                      <Typography variant="h6">
                        {(transaction?.netAmountCents / 100).toFixed(2)}{" "}
                        {transaction?.currency?.code || "EGP"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box
                      sx={{ p: 2, backgroundColor: "white", borderRadius: 1 }}
                    >
                      <Typography variant="subtitle2" color="text.secondary">
                        Total Amount
                      </Typography>
                      <Typography variant="h6">
                        {(transaction?.totalAmountCents / 100).toFixed(2)}{" "}
                        {transaction?.currency?.code || "EGP"}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            );
          })}
        </>
      )}

      <div className="cont">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h2>Total Transactions: {transactionsNumber}</h2>

          <a
            href={`${BaseURL}/admin/dashboard/payment/transactions/excel?${
              sortBy ? `&sortBy=${sortBy}` : ""
            }${sortOrder ? `&sortDesc=${sortOrder}` : ""}${
              getFilterQueryString(filters)
                ? `&${getFilterQueryString(filters)}`
                : ""
            }${search ? `&search=${search}` : ""}&timeZone=${
              Intl.DateTimeFormat().resolvedOptions().timeZone
            }`}
            target="_blank"
          >
            <PrimaryButton
              classBtn={"center editButton"}
              text={"Download Excel"}
              style={{
                textTransform: "capitalize",
                borderRadius: "5px",
                color: "var(--text-secondary)",
                backgroundColor: "var(--text-primary)",
                height: "40px",
                padding: "0 30px",
                fontSize: "15px",
              }}
            />
          </a>
        </Box>
        <Box
          sx={{
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {isMobile && (
            <IconButton
              onClick={() => setShowFilters(!showFilters)}
              sx={{
                backgroundColor: "var(--primary)",
                color: "white",
                "&:hover": {
                  backgroundColor: "#8a0505",
                },
              }}
            >
              <FilterListIcon />
            </IconButton>
          )}
        </Box>

        <Collapse in={showFilters}>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} md={3}>
              <TextFieldInput
                searchIcon={true}
                Required={false}
                type="text"
                placeholder={"Search"}
                className="SearchBar"
                name={"search"}
                change={(e) => setSearchData(e.target.value)}
                newValue={searchData}
                searchAction={() => {
                  if (search != searchData) {
                    setSearch(searchData);
                    setPage(0);
                  }
                }}
                keyDown={(e) => {
                  if (e.keyCode === 13)
                    if (search != searchData) {
                      setSearch(searchData);
                      setPage(0);
                    }
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Sort By</InputLabel>
                <Select
                  value={sortBy}
                  label="Sort By"
                  onChange={handleSortChange}
                  defaultValue={sortBy}
                >
                  {[{ id: "createdAt", label: "Date" }].map((column) => (
                    <MenuItem key={column.id} value={column.id}>
                      {column.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Order</InputLabel>
                <Select
                  value={sortOrder}
                  label="Order"
                  onChange={handleSortOrderChange}
                >
                  <MenuItem value={true}>Newest to Oldest</MenuItem>
                  <MenuItem value={false}>Oldest to Newest</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Manual Payment Method</InputLabel>
                <Select
                  value={filters.manualTransactionType}
                  label="Manual Payment Method"
                  name="manualTransactionType"
                  onChange={handleFilterChange}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="cash">Cash</MenuItem>
                  <MenuItem value="vodafoneCash">Vodafone Cash</MenuItem>
                  <MenuItem value="bankTransfer">Bank Transfer</MenuItem>
                  <MenuItem value="instaPay">InstaPay</MenuItem>
                  <MenuItem value="exception">Exception</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Collapse>

        <Paper
          className="tableCont"
          sx={{ width: "fit-content", minWidth: "100%" }}
        >
          {!loading ? (
            <>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <StyledTableCell
                          key={column.id}
                          align={column.align}
                          style={{
                            minWidth: column.minWidth,
                          }}
                        >
                          {column.label}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {transactions?.map((transaction) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={transaction.id}
                        >
                          {columns.map((column) => {
                            const value = transaction[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ padding: "10px" }}
                              >
                                {column.id == "account" ? (
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      navigate(`/accounts/${value?.id}`)
                                    }
                                  >
                                    {value?.code}
                                  </span>
                                ) : column.id == "netAmountCents" ||
                                  column.id == "totalAmountCents" ? (
                                  `${(value / 100).toFixed(2)} ${
                                    transaction?.currency?.code
                                  }`
                                ) : column.id == "createdAt" ? (
                                  `${new Date(
                                    value
                                  )?.toLocaleDateString()} / ${new Date(
                                    value
                                  )?.toLocaleTimeString()}`
                                ) : column.id == "manualTransaction" ? (
                                  value?.type ?? "-"
                                ) : (
                                  value ?? "-"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                {!transactions?.length ? (
                  <h3 style={{ textAlign: "center", margin: "50px" }}>
                    No transactions Added Yet!!
                  </h3>
                ) : (
                  ""
                )}
              </TableContainer>
              <Pagination
                count={pageCount}
                page={page + 1}
                onChange={handleChangePage}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "0 20px`",
                  padding: "20px",
                  color: "var(--primary)",
                  "& .Mui-selected": {
                    backgroundColor: "var(--primary)",
                    color: "white",
                  },
                }}
              />
            </>
          ) : (
            <div className="loadingBox">
              <BarLoader color="var(--primary)" />
            </div>
          )}
        </Paper>
      </div>
    </div>
  );
}

export default Transactions;
